import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-training1',
  templateUrl: './training1.component.html',
  styleUrls: ['./training1.component.css']
})
export class Training1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
